import script from "./ModelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelPage.vue?vue&type=script&setup=true&lang=js"

import "./ModelPage.vue?vue&type=style&index=0&id=32688150&lang=css"
import "./ModelPage.vue?vue&type=style&index=1&id=32688150&scoped=true&lang=css"

import exportComponent from "/Users/allard/WebstormProjects/vite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32688150"]])

export default __exports__